import React, { useEffect, useState } from 'react';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAlignLeft } from "@fortawesome/free-solid-svg-icons"; 
import {Link, useNavigate} from "react-router-dom";
import ListGroup from 'react-bootstrap/ListGroup';
import Rightbar from './Rightbar';
import { useSelector} from 'react-redux';
import { useParams } from "react-router";
import moment from 'moment';
import { exhibitorEventGuideline } from '../../Service';
import { viewExhibitorEventGuideline } from '../../Service';
import Swal from "sweetalert2";


export default function Guidelines() {
    const [sidebar, setsidebar] = useState(false);
    const [mainbar, setmainbar] = useState(false);
    const toggle = () => {
        setsidebar(!sidebar);
        setmainbar(!mainbar);
    }
    const initialValues = { accept: "", user_id:"", event_id:""};
    //const [formValues, setFormValues] = useState(initialValues);
    const [formValues, setFormValues] = useState([]);
    const [formErrors, setFormErrors] = useState({});
    let loggedUser = useSelector(store => store.user['user']);
    let user_id = '';
    if(loggedUser){
        user_id = loggedUser.id    
    }
    const { id } = useParams();
    const event_id  = id;
    const navigation = useNavigate();
   
    //const event_id= (new URLSearchParams(window.location.search)).get("event_id")
  
    //console.log('event_id guid 35',event_id)

    const [list, setList] = useState([]);
 
    useEffect(() => {
        var bodyFormData = new FormData();
        bodyFormData.append('user_id', user_id);
        bodyFormData.append('event_id', event_id);
        //viewExhibitorEventGuideline(bodyFormData).then(res => setList(res.data.data))
        viewExhibitorEventGuideline(bodyFormData).then(res => setHandleExhibitorResponse(res))
        
      },[]);

      const setHandleExhibitorResponse = (res) => 
      {
        setList(res.data.data );
        setFormValues(res.data.data);
      }

      const accepstatus = list.accepted_status;
      //console.log('accepstatus',accepstatus)
    // const hanldeChange = (e) => {
    //     formValues[e.target.name]=  e.target.value;

    //     console.log('62', formValues)
    //     setFormValues(formValues);
    // }


    const hanldeChange = (e) => {
        console.log(e.target.name+'__'+e.target.value);
        const value=e.target.value;
        const field=e.target.name;
        setFormValues(prevState => ({
        ...prevState,
        [field]: value }));
        }
        
    const handleSubmit = (e) => {
        e.preventDefault();
        console.log(formValues);
        const errorCount = validate(formValues);
        setFormErrors(errorCount);
        if(errorCount.status){
		var bodyFormData = new FormData();
        bodyFormData.append('accepted_status', formValues.accept ? formValues.accept : list.accepted_status);
        bodyFormData.append('user_id', user_id);
        bodyFormData.append('event_id', event_id);
        exhibitorEventGuideline(bodyFormData).then(res => handleResponse(res.data.data))
        }
    }
    
    const handleResponse = (response) => {
        console.log("response 52",response)
        if(response.accepted_status=='No' || response.accepted_status=='NO')
        {
            Swal.fire(
                'GUIDELINES',
                'Thank you for your valuable response',
                'success'
              )
            navigation("/Exhibitorhome");
        }
        else
        {

            navigation('/createProfile/'+event_id);
            window.scrollTo(0, 0);
        }
    }

    


    const validate = (values) => 
    {
        
        const errors = {};
        errors.status = true;
        var error_val=0;
        if(!values.accept || values.accept == null){
            if(!list.accepted_status){
            errors.accept = 'Please read and accept the application guidelines';
            error_val = 1;
            errors.status = false;
            }
        }
        else {
            errors.status = true;
        }
        return errors;
    }

    
    return(
      <>
 
<section className="sec-container" >
   <div className='container'>
      <div className='portalevent'>
         <div className='row'>
            <div className={`col-md-3 portal-sidebar leftbar-close ${sidebar ? 'close' : ''}`}>
                  <div >
                  <Rightbar event_id={event_id}/>
                  </div>
               </div>
               <div className={`col-md-9 rightbar-open ${mainbar ? 'open' : ''}`}>
                  <div className='rightbar '>
                  <Button variant="outline-info" onClick={toggle}>
                    <FontAwesomeIcon icon={faAlignLeft} />
                  </Button>
 
                            <h1>GUIDELINES</h1>
 
                            <Form onSubmit={handleSubmit}>
                                <Form.Group>
                                    <Form.Label>Please read and accept the application guidelines below. </Form.Label>
                                    <Form.Select aria-label="Do you accept?" name="accept" defalutValue={formValues.accept} onChange={hanldeChange}>
                                        <option value=''>Do you accept?</option>
                                        <option value="Yes" selected={list.accepted_status=="Yes" ? "selected" : ""} >Yes</option>
                                        <option value="No"  selected={list.accepted_status=="No" ? "selected" : ""}>No</option>
                                    </Form.Select>
                                    <p className="error">{formErrors.accept}<br/><br/></p>
                                </Form.Group>
                                <Button variant="primary" type="submit" className='common-btn'>
                                    Continue
                                </Button>
                            </Form>
                            <hr />
                            <h2>Application Guidelines</h2>
                            <p>
                                The following guidelines must be accepted for your application to be deemed 
                                complete and ready for consideration by photo l.a.
                            </p>
                            <ListGroup>
                                <ListGroup.Item>
                                    <li>All required fields information requested by the online application must be 
                                    provided by applicants. Please provide as specific and detailed as possible when 
                                    requested under the <Link to="photola/BoothDetails">"Exhibitor Details"</Link> section of the application. Please contact 
                                    Exhibitor Relations at er@photola.com for any additional materials you would like 
                                    to submit.</li>
                                </ListGroup.Item>
                                <ListGroup.Item>
                                <li>Applicant must attach five (5) digital images of specific works they are proposing 
                                    to present at photo l.a. Complete artist and caption fields as required. Any additional 
                                    materials may be emailed to er@photola.com. </li>
                                </ListGroup.Item>
                                <ListGroup.Item>
                                <li>All completed applications will require a deposit of 10% of the total booth cost in 
                                    addition to a non-refundable $200 administrative application fee. The 10% deposit will 
                                    be applied toward total booth fee. Applications will not be reviewed without a deposit 
                                    made to photo l.a. </li>
                                </ListGroup.Item>
                                <ListGroup.Item>
                                <li>photo l.a. will review all applications based on quality of the works presented, 
                                    overall proposal and application by Gallery in accordance with photo l.a. established 
                                    standards and curatorial direction. </li>
                                </ListGroup.Item>
                                <ListGroup.Item>
                                <li>A letter of acceptance and exhibitor contract is provided to successful applicants 
                                    into photo l.a. when the selection process is completed. Applicants not accepted will 
                                    also be notified and the 10% deposit will be refunded; the $200 administrative 
                                    application fee is non-refundable. </li>
                                </ListGroup.Item>
                                <ListGroup.Item>
                                <li> A signed exhibitor contract is required for participation by the deadline specified 
                                    on it. Upon receipt of contract by photo l.a. Exhibitor Relations manager, exhibitors 
                                    will receive all information required and related to photo l.a. schedules, deadlines, 
                                    VIP programs and technology related to the fair. </li>
                                </ListGroup.Item>
                            </ListGroup>
                        </div>
                </div>
            </div>
            </div>
            </div>
 
        </section>
        </>
    )
}